module.exports = __webpack_public_path__ + "static/media/S1N12-6.b1a91baf.svg";